import React from 'react'
import ProductForm from 'views/shared/ProductForm'
import WWBagelsProduct from 'models/WWBagelsProduct'
import WWBagelsPackage from './WWBagelsPackage'

const productOptions = {
  packagingInfo: <WWBagelsPackage />,
  productTitle: 'Whole Wheat Bagels',
  model: WWBagelsProduct,
  validCategories: ['16'],
  validSubCategories: ['010'],
}

const WWBagels = () => <ProductForm product={productOptions} />

export default WWBagels
